import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/app/delegation-control-center/components/DelegationControlInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/components/common/Breadcrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/components/common/Sidebar.tsx");
